module.exports = __webpack_public_path__ + "static/media/cheerful-happy.8b65f90c.png";